import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://bkhaviccwhpouwmuydef.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJraGF2aWNjd2hwb3V3bXV5ZGVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwMDcxNTksImV4cCI6MjA1ODU4MzE1OX0.ieGzxE969hufQczGVAOf6j-v-ra88qjNwaTkbwHp5WM";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});

console.log("Supabase client initialized:", supabase);
